import { createDomain } from 'effector'
import { FieldValues, Path, UseFormSetError } from 'react-hook-form'
import { AxiosErrorType } from '~/shared/api'

const domain = createDomain('shared.ui.form.formProvide')

export type FormSetError = UseFormSetError<FieldValues>

const getPointerPath = (pointer: string) => {
  const lastPart = pointer.split('/').pop()
  return lastPart as Path<FieldValues>
}

export const triggerErrorFx = domain.createEffect({
  handler: ({
    error,
    formSetError,
  }: {
    error: AxiosErrorType
    formSetError: FormSetError
  }) => {
    const errors = error.response?.data?.errors
    if (!errors) return

    errors.forEach((error: { source: { pointer: string }; detail: string }) => {
      const field = getPointerPath(error.source.pointer)

      if (!field) return

      formSetError(field, {
        type: 'manual',
        message: error.detail,
      })
    })
  },
})
